import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  ElementRef,
  ChangeDetectionStrategy,
  forwardRef,
  ChangeDetectorRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-panel',
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PanelComponent),
      multi: true,
    },
  ],
})
export class PanelComponent implements OnInit, ControlValueAccessor {
  @Input()
  label: string;

  @Input()
  hint: string;

  @Input()
  public get open() {
    return this._open;
  }
  public set open(value) {
    if (value !== this.open) {
      this._open = value;
      this.value = value;
    }
  }
  private _open: boolean;

  @Input()
  public get value() {
    return this._value;
  }
  public set value(value) {
    if (value !== this.value) {
      this._value = value;
      this.open = value;
      this.propagateChange(this.value);
      this.changeRef.markForCheck();
    }
  }
  private _value: boolean;

  @Input()
  toggleType: 'arrow' | 'checkbox' | 'none' = 'none';

  @Input()
  toggleable = true;

  @Input()
  dataTestAttributeVal;

  @Input()
  isCompact = false;

  @Input()
  noPadding = false;

  @Input()
  active = true;

  @Output()
  opened: EventEmitter<boolean> = new EventEmitter<boolean>();

  disabled = false;

  constructor(private changeRef: ChangeDetectorRef) {}

  ngOnInit() {}

  // ---------- Handlers ----------
  handleClickHeader() {
    if (this.toggleType === 'none' || this.disabled || !this.toggleable) {
      return;
    }

    this.open = !this.open;

    // Only emit opened event when triggered by user. We do this so the application can react
    // specifically to user input, without interference from programatic changes of the opened
    // state.
    this.opened.emit(this.open);
  }

  onChange: any = () => {};
  onTouched: any = () => {};

  writeValue(value: boolean): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  propagateChange = (_: any) => {};
}
